/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrencyResponseDto
 */
export interface CurrencyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CurrencyResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyResponseDto
     */
    code: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrencyResponseDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the CurrencyResponseDto interface.
 */
export function instanceOfCurrencyResponseDto(value: object): value is CurrencyResponseDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function CurrencyResponseDtoFromJSON(json: any): CurrencyResponseDto {
    return CurrencyResponseDtoFromJSONTyped(json, false);
}

export function CurrencyResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'code': json['code'],
        'isActive': json['isActive'],
    };
}

export function CurrencyResponseDtoToJSON(json: any): CurrencyResponseDto {
    return CurrencyResponseDtoToJSONTyped(json, false);
}

export function CurrencyResponseDtoToJSONTyped(value?: CurrencyResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'isActive': value['isActive'],
    };
}

